import { render, staticRenderFns } from "./PrintOrderTableRowItems.vue?vue&type=template&id=0034ba20&"
import script from "./PrintOrderTableRowItems.vue?vue&type=script&lang=js&"
export * from "./PrintOrderTableRowItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports